import DeliveryForm from './DeliveryForm';

export default DeliveryForm;
